// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

import { reelsAvgTimeWatchedConfig } from '../reelsAvgTimeWatched';

export const reelsAvgTimeWatchedMVConfig: KpiType<
    typeof MediaViewerKpiLoader,
    typeof MediaViewerKPI
> = {
    ...reelsAvgTimeWatchedConfig,
    name: 'kpi.facebook.avg_time_watched',
    id: 'video_views_avg_time_watched',
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
